import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCodeMedium"><Path d="M17 7.5L21.5 12L17 16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7 16.5L2.5 12L7 7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCodeMedium;
